import React, { Component } from 'react';
import { Table, Button, Col, Form } from 'react-bootstrap';
import Fuse, { FuseOptions } from 'fuse.js';
import SearchEquity from './SearchEquity';
import SearchEquityModal from './SearchEquityModal';
import { Equity } from '../../../../api/src/interfaces/shared';

interface Props {
  equities: Equity[];
}

interface State {
  equities: Equity[];
  modalEquity?: Equity;
  defaultNumResults: number;
  show: boolean;
  numResults: number;
  loading?: boolean;
}

export default class SearchTable extends Component<Props, State> {
  /*
    This component is listing equities, and a search bar. When the user adds input to the
    search bar, the equities will automatically update with results matching the query.
  */
  fuse: Fuse<Equity, FuseOptions<Equity>>;

  constructor(props: Props) {
    super(props);

    this.state = {
      equities: props.equities,
      defaultNumResults: 30,
      numResults: 30,
      show: false
    };

    // Initialize the searcher with search options
    this.fuse = new Fuse(props.equities, {
      keys: ['name'],
      threshold: 0.2,
      shouldSort: true
    });

    this.registerScrollSpy();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.isScrolledToBottom);
  }

  registerScrollSpy = () => {
    window.addEventListener('scroll', this.isScrolledToBottom);
  };

  isScrolledToBottom = () => {
    const offset = 5;
    const scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    const scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    const scrolledToBottom =
      scrollTop + window.innerHeight + offset >= scrollHeight;

    if (scrolledToBottom) {
      this.showTenMoreEquities();
    }
  };

  showTenMoreEquities = () => {
    const { numResults } = this.state;
    this.setState({
      show: false,
      numResults: numResults + 10
    });
  };

  showModal = (equity: Equity) => {
    // Show the modal and set the modal to display the equity clicked.
    this.setState({ show: true, modalEquity: equity });
  };

  hideModal = () => {
    this.setState({ show: false });
  };

  search = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Extract the query
    const query = event.target.value;
    // Only show the default number of results
    const { defaultNumResults } = this.state;

    // Start with default state in case we get no hits
    let result = this.props.equities;

    // Only search if we have at one characters
    if (query.length >= 1) {
      // Search in the equities, and update the state with the results.
      // @ts-ignore
      result = this.fuse.search(query);
    }

    this.setState({
      show: false,
      equities: result,
      numResults: defaultNumResults
    });
  };

  render() {
    const { numResults } = this.state;
    return (
      <div>
        <p className="row-info"> Klikk på en rad for mer info </p>
        <Col md={12}>
          <Form.Group controlId="formBasicText">
            <Form.Label>Søk etter fond/aksje</Form.Label>
            <Form.Control
              type="text"
              placeholder="Søk etter fond/aksje"
              onChange={this.search}
            />
          </Form.Group>
        </Col>
        <Col md={12}>
          <Table hover responsive size="sm">
            <thead>
              <tr>
                <th>Navn</th>
                <th className="hide-on-500px">Oppdatert</th>
                <th>Siste dag</th>
                <th>Kurs</th>
              </tr>
            </thead>
            <tbody>
              {this.state.equities.map((equity, i) => {
                if (i < numResults) {
                  return (
                    <SearchEquity
                      key={i}
                      onClick={() => this.showModal(equity)}
                      equity={equity}
                    />
                  );
                }
                return null;
              })}
              <tr className="no-results">
                <td colSpan={4}>Ingen treff på søket..</td>
                <td className="hide-on-500px" />
              </tr>
            </tbody>
          </Table>
          {this.state.loading || this.state.equities.length < numResults ? (
            ''
          ) : (
            <div className="show-more-results">
              <Button variant="light" onClick={this.showTenMoreEquities}>
                Vis 10 flere resultater
              </Button>
            </div>
          )}
        </Col>
        <SearchEquityModal
          show={this.state.show}
          hide={this.hideModal}
          equity={this.state.modalEquity}
        />
      </div>
    );
  }
}
